import React, { useContext } from 'react';
import { AuthCallbacks } from './Auth';

export const AuthContext = React.createContext<AuthCallbacks>({} as AuthCallbacks);

export const useAuthContext = (): AuthCallbacks => {
  return useContext(AuthContext);
};
